export type ReceiptSearchTargetLabel = (typeof ReceiptSearchTargetLabel)[keyof typeof ReceiptSearchTargetLabel];
export const ReceiptSearchTargetLabel = {
  /** 航空券 */
  ETICKET: 'eTicket',
  /** EMD */
  EMD: 'emd',
} as const;
